<script>
import { mapState } from 'vuex';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'atlas-params',

  computed: {
    ...mapState('breakdown', ['primaryGeo']),

    indicatorId() {
      return this.$route.params.indicator;
    },

    geoCompare() {
      return this.$route.query.geo_compare ?? undefined;
    },

    breakdownId() {
      return this.$route.query.breakdown;
    },

    args() {
      return Object.keys(this.$route.query)
        .filter(
          (key) =>
            !['breakdown', 'geo', 'geo_compare', 'mode', 'tour'].includes(key),
        )
        .reduce((acc, key) => ({ ...acc, [key]: this.$route.query[key] }), {});
    },

    geoComplexity() {
      // const validValues = [
      //   'test',
      //   'x1',
      // ];

      // return this.$route.query.complexity &&
      //   validValues.includes(this.$route.query.complexity)
      //   ?
      //   this.$route.query.complexity
      //   :
      //   undefined;

      return this.$route.query.complexity;
    },
  },

  // Vue 3 Upgrade: Slots Unification [https://v3.vuejs.org/guide/migration/slots-unification.html#overview]
  render() {
    return this.$slots.default({
      indicatorId: this.indicatorId,
      breakdownId: this.breakdownId,
      args: this.args,
      geoCode: this.$route.query.geo || this.primaryGeo?.id,
      geoCompareCode: this.$route.query.geo_compare,
      geoType: this.$route.query.geo_type,
      geoComplexity: this.geoComplexity,
    });
  },
});
</script>
